<template>
  <div>
    <RoutinesForm
      :routinesProp="routines"
      :subjectPermission="subjectPermission"
      @save-routine="saveConfig"
    />
  </div>
</template>
<script>
import RoutinesForm from './RoutinesForm.vue';
import notify from '../../utils/notify';

import routineApiService from '../../services/routine.api';

export default {
  name: 'RoutinesCommon',
  components: {
    RoutinesForm,
  },
  props: {
    subjectPermission: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      routines: [],
    };
  },
  async mounted() {
    this.getRoutineConfigs();
  },
  methods: {
    getRoutineConfigs() {
      this.$vs.loading();
      routineApiService
        .getAll()
        .then((response) => {
          this.$vs.loading.close();
          this.routines = response;
        })
        .catch((error) => {
          this.$vs.loading.close();
          notify.notifyFail(this.$vs, error);
        });
    },
    saveConfig(payload) {
      this.$vs.loading();
      routineApiService
        .save(payload)
        .then(() => {
          this.$vs.loading.close();
          this.getRoutineConfigs();
          notify.notifySuccess(this.$vs, 'Configuração salva com sucesso!');
        })
        .catch((error) => {
          this.$vs.loading.close();
          notify.notifyFail(this.$vs, error);
        });
    },
  },
};
</script>
